import React, { useEffect, useState } from 'react';
import { PageTitle } from '@michelin/acid-components';

let currentPageSetTitle: ((title: React.ReactNode) => void) | null = null;

export function setPageTitle(title: React.ReactNode) {
  if (currentPageSetTitle !== null) currentPageSetTitle(title);
}

interface CustomPageTitleProps {
  title?: string;
  children?: React.ReactNode;
}

function CustomPageTitle(props: CustomPageTitleProps) {
  const { title = '', children: propsChildren } = props;
  const [children, setChildren] = useState(propsChildren);

  useEffect(() => {
    currentPageSetTitle = setChildren;
    return () => {
      currentPageSetTitle = null;
    };
  }, [setChildren, props]);

  if (!children) {
    return <PageTitle title={title} height={50} />;
  }

  return <>{children}</>;
}

export default CustomPageTitle;
